import { useEffect } from 'react';
import Swal from 'sweetalert2';

const ResetAddressModal = ({ isOpen, selectedAddress, onConfirm, onClose }) => {
    const showResetModal = () => {
        // CSS stilleri ekle
        const style = document.createElement('style');
        style.textContent = `
            .reset-address-modal {
                border-radius: 8px !important;
                box-shadow: 0 4px 20px rgba(0,0,0,0.15) !important;
            }
            .reset-address-title {
                font-size: 16px !important;
                font-weight: 600 !important;
                color: #2c3e50 !important;
                margin-bottom: 15px !important;
            }
            .reset-address-content {
                font-size: 14px !important;
                line-height: 1.4 !important;
            }
            .swal2-popup {
                padding: 20px !important;
            }
            .swal2-actions {
                margin-top: 20px !important;
            }
            .swal2-confirm, .swal2-cancel {
                padding: 8px 20px !important;
                font-size: 14px !important;
                border-radius: 4px !important;
            }
        `;
        document.head.appendChild(style);

        Swal.fire({
            title: 'Adresi Resetle',
            html: `
                <div style="text-align: center;">
                    <div style="font-size: 14px; color: #6c757d; margin-bottom: 8px;">
                        Seçili Adres Bilgileri:
                    </div>
                    ${selectedAddress ? `
                        <div style="
                            background-color: #f8f9fa; 
                            padding: 8px; 
                            border-radius: 4px; 
                            border: 1px solid #e9ecef;
                            margin-bottom: 15px;
                            display: inline-block;
                            min-width: 160px;
                        ">
                            <div style="
                                font-size: 14px; 
                                font-weight: bold; 
                                color: #28a745; 
                                margin-bottom: 3px;
                            ">
                                ${selectedAddress.coordinate}${selectedAddress.direction}-${selectedAddress.row_number}
                            </div>
                            <div style="font-size: 12px; color: #6c757d;">
                                Kapasite: ${selectedAddress.capacity} | Sayılan: ${selectedAddress.scan_count} | Olan: ${selectedAddress.physical_chassis_count}
                            </div>
                        </div>
                    ` : '<div style="color: #6c757d; font-size: 12px;">Adres bilgisi bulunamadı</div>'}
                    
                    <div style="
                        font-size: 18px; 
                        font-weight: bold; 
                        color: #dc3545; 
                        margin-top: 15px;
                        margin-bottom: 5px;
                    ">
                        Emin misiniz?
                    </div>
                </div>
            `,
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Evet',
            cancelButtonText: 'İptal',
            width: '320px',
            padding: '20px',
            customClass: {
                popup: 'reset-address-modal',
                title: 'reset-address-title',
                htmlContainer: 'reset-address-content'
            },
            showClass: {
                popup: 'swal2-show'
            },
            hideClass: {
                popup: 'swal2-hide'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                onConfirm();
            } else {
                onClose();
            }
            // CSS stillerini temizle
            document.head.removeChild(style);
        });
    };

    // isOpen değiştiğinde modal'ı göster
    useEffect(() => {
        if (isOpen) {
            showResetModal();
        }
    }, [isOpen]);

    return null; // Bu bileşen sadece modal gösterir, render etmez
};

export default ResetAddressModal; 